import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { CandidateSearch } from '../models/candidate.model';
import { setCandidateSearch } from '../actions/candidate-search.actions';

export const initialState: CandidateSearch = null;

const reducer = createReducer(initialState,
  on(setCandidateSearch, (state, candidateSearch) => candidateSearch)
);

export const fromCandidateSearch = {
  selectCandidateSearchState: createFeatureSelector<CandidateSearch>('candidateSearch'),
};

export function candidateSearchReducer(state, action) {
  return reducer(state, action);
}
